import angular from 'angular';

angular
  .module('cloudX')
  .controller('AuthResourcesDialogCtrl', [
    'resourceFactorySvc',
    'flySvc',
    '$element',
    'close',
    'stream',
    '$filter',
    'dialogsSvc',
    authResourcesDialogCtrl,
  ]);

function authResourcesDialogCtrl(
  resourceFactorySvc,
  flySvc,
  $element,
  close,
  stream,
  $filter,
  dialogsSvc,
) {
  var vm = this;
  vm.useDefault = false;
  vm.search = '';
  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };
  var streamResource = resourceFactorySvc.get('invoiceStream');

  vm.categories = [];
  streamResource.getResources(
    {
      id: stream.id,
    },
    function(data) {
      vm.categories = data.map(item => {
        item.resource = item.items.find(x => x.isDefault);
        item.code = (item.resource && item.resource.code) || '';
        item.name =
          (item.code ? `${item.code} – ` : '') + //Prepend code of default resource
          $filter('translateList')(item.categoryId, 'resourcecategory', item.categoryName);

        item.items = item.items
          .filter(x => !x.isDefault)
          .map(r => ({
            ...r,
            name:
              (r.code ? `${r.code} – ` : '') + $filter('translateList')(r.id, 'resource', r.name),
            categoryName: item.name,
          }));

        item.search = item.name + ';' + item.items.map(x => x.name).join(';');
        return item;
      });
    },
    showError,
  );

  vm.searchResource = function(resource) {
    if (!vm.search) return true;
    if (resource.categoryName.toLowerCase().indexOf(vm.search.toLowerCase()) >= 0) return true;
    return resource.name.toLowerCase().indexOf(vm.search.toLowerCase()) >= 0;
  };

  var flattenResources = () =>
    vm.categories.reduce((a, category) => [...a, category.resource, ...category.items], []);

  vm.default = function() {
    if (vm.useDefault) return;
    vm.useDefault = true;
    return dialogsSvc
      .showYesNoCancel(
        'msgConfirmPropogateChangesTitle',
        'msgConfirmPropogateResourceForfaitChanges',
      )
      .then(
        function(result) {
          if (result === null) {
            vm.useDefault = false;
            return false; // Cancel changes
          }

          streamResource.saveResources(
            {
              id: stream.id,
              updateForfaitStatus: result,
            },
            [],
            function() {
              close(true, 500);
              $element.modal('hide');
            },
            showError,
          );
        },
        function() {
          vm.useDefault = false;
          return false; // Cancel changes
        },
      );
  };
  vm.toggleInForfait = function(resource) {
    vm.useDefault = false;
    resource.invoiceStreamInForfait = resource.inForfait;
  };
  vm.resetInForfait = function(resource) {
    resource.invoiceStreamInForfait = null;
    resource.inForfait = resource.assignmentTemplateInForfait ?? resource.resourceInForfait; //Combined value
  };
  vm.save = function() {
    return dialogsSvc
      .showYesNoCancel(
        'msgConfirmPropogateChangesTitle',
        'msgConfirmPropogateResourceForfaitChanges',
      )
      .then(
        function(result) {
          if (result === null) return false; // Cancel changes
          var resources = flattenResources();

          streamResource.saveResources(
            {
              id: stream.id,
              updateForfaitStatus: result,
            },
            resources,
            function() {
              close(true, 500);
              $element.modal('hide');
            },
            showError,
          );
        },
        function() {
          return false; // Cancel changes
        },
      );
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
